// extracted by mini-css-extract-plugin
module.exports = {"section":"AsideSection_section__9Fjcm"};